import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { clearPublicChatRequested } from 'features/chat/actions';

const ClearPublicChatConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { hasPermissions } = usePermissions();
  const canClearChat = hasPermissions(PermissionTypes.clearChat);

  useEffect(() => {
    if (!canClearChat) {
      dispatch(closeModal('clearPublicChatConfirmation'));
    }
  }, [canClearChat, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('clearPublicChatConfirmation'));
  };

  const handleOk = () => {
    dispatch(clearPublicChatRequested());
    dispatch(closeModal('clearPublicChatConfirmation'));
  };

  return (
    <ConfirmationDialog
      open={canClearChat}
      title={t('clear_public_chat_confirmation.title')}
      description={t('clear_public_chat_confirmation.description')}
      cancelText={t('clear_public_chat_confirmation.btn_cancel_label')}
      okText={t('clear_public_chat_confirmation.btn_ok_label')}
      onCancel={handleCancel}
      onOk={handleOk}
      hideCloseButton
      okButtonProps={{ color: 'error' }}
    />
  );
};

export default ClearPublicChatConfirmation;
